import { Button, Dialog, Stack, TextField, Typography } from "@mui/material";

import * as React from "react";
import { useTranslation } from "react-i18next";

type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
  onDone: (text: string) => void;
};
export const CanvasTextInput: React.FC<Props> = ({ open, setOpen, onDone }) => {
  const { t } = useTranslation();
  const [text, setText] = React.useState<string>("");

  React.useEffect(() => {
    setText("");
  }, [open]);

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
      <Stack direction="column" spacing={1} p={2}>
        <Typography>{t('settings.rampsSettings.rampEditor.canvasTextInput.title')}</Typography>
        <TextField
          variant="outlined"
          size="small"
          autoFocus
          type="text"
          label={t('settings.rampsSettings.rampEditor.canvasTextInput.nameLabel')}
          fullWidth
          onChange={(e) => setText(e.target.value)}
          value={text}
        />
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button
            onClick={() => {
              setOpen(false);
              setText("");
            }}
            color="primary"
          >
            {t('settings.rampsSettings.rampEditor.canvasTextInput.cancel')}
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={() => {
              setOpen(false);
              onDone(text);
            }}
          >
            {t('settings.rampsSettings.rampEditor.canvasTextInput.save')}
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};
